import { AsYouType, type CountryCode } from 'libphonenumber-js';

type CountryCodeLib = {
	name: string;
	shortName: CountryCode;
	code: number | null;
};

export const countryCodeLib: CountryCodeLib[] = [
	{
		name: 'United States',
		shortName: 'US',
		// Canada is also 1
		code: 1,
	},
	{
		name: 'Mexico',
		shortName: 'MX',
		code: 52,
	},
];

export const getCountry = (code: number): CountryCode => {
	const countryCode = countryCodeLib.find((c) => c.code === code);

	return countryCode?.shortName || 'US';
};

export const getCountryCallingCode = (shortName: CountryCode): number => {
	const countryCode = countryCodeLib.find((c) => c.shortName === shortName);

	return countryCode?.code || 1;
};

export const formatPhoneNumber = (phoneNumber: string, countryCode: number) => {
	if (!phoneNumber) {
		return '';
	}

	const country = getCountry(countryCode);

	const formatter = new AsYouType(country || undefined);

	return formatter.input(phoneNumber);
};
